export const OktaClientId = '0oaop0jixngcdBAzt696'
export const ENV = 'staging2' as string
export const OVERSIGHT_ENV_NAME = 'oversight-staging2'
export const GCS_ENV_NAME = 'staging2'
export const SUBDOMAIN_SUFFIX = 'gcs-staging'
